import { types } from 'mobx-state-tree'

import { SearchContactInfoStore } from './searchContactInfo'
import { SearchCriteriaStore } from './searchCriteria'
import { ResultsStore } from './results'
import { FlowStore } from './flow'

export const ParkingFlowStore = types.model('ParkingFlowStore', {
  searchCriteria: types.optional(SearchCriteriaStore, {}),
  contactInfo: types.optional(SearchContactInfoStore, {}),
  results: types.optional(ResultsStore, {}),
  flow: types.optional(FlowStore, {})
})
